import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssociationController } from '../../association.controller';
import { FullscreenDialogComponent } from '../fullscreen-dialog/fullscreen-dialog.component';

@Component({
  selector: 'ui-footer-association-dialog',
  templateUrl: './fullscreen-dialog-footer.component.html',
  styleUrls: [ './fullscreen-dialog-footer.component.less' ],
})
export class FullscreenDialogFooterComponent {
  @Input() isFormDirty: boolean = false;
  @Input() selectedContentIndex: number;
  @Input() associationController: AssociationController;
  @Input() selectedTabIdx: number;
  @Output() nextContent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() handleSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() handleNewItem: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private associationDialogComponent: FullscreenDialogComponent,
  ) {
  }

  public disableSubmit(): boolean {
    return !(this.associationDialogComponent.uiFormComponent.form.valid && this.isFormDirty);
  }

  nextPage(): void {
    this.nextContent.emit(true);
  }

  submit(event: any): void {
    this.handleSubmit.emit(event);
  }

  submitNewItem(): void {
    this.handleNewItem.emit();
  }

  cancel(): void {
    if (this.associationDialogComponent) {
      this.associationDialogComponent.tabIndexChange(0);
    }
  }

  clear(): void {
    if (this.associationDialogComponent.searchReference && this.associationDialogComponent.searchReference.instance) {
      this.associationDialogComponent.searchReference.instance.params = {};
    }
  }

  removeSelectedItem(item: any): void {
    const index = this.associationController.selectedItems.indexOf(item, 0);
    if (index > -1) {
      this.associationController.selectedItems.splice(index, 1);
      this.associationController.chipInjectors.splice(index, 1);
    }
    if (this.selectedTabIdx === 0
      && this.selectedContentIndex === 1
      && this.associationController.selectedItems.length === 0) {
      this.nextContent.emit(false);
    }
  }
  public isEqual(obj1: any, obj2: any): boolean {
    return _.isEqual(obj1, obj2);
  }
}
